<template>
  <div class="eventSchedule">
    <Breadcrumb />
    <el-main>
      <EventDesc />
      <el-row class="nofull event_content">
        <EventMenu :menuActiveId="menuActiveId" />
        <el-main>
          <div
            class="contentEmpty"
            v-if="
              eventDesc.setting_json.schedule === '' ||
              eventDesc.setting_json.schedule === '<p></p>' ||
              eventDesc.setting_json.schedule === null ||
              eventDesc.setting_json.schedule === undefined
            "
          >
            暂无内容
          </div>
          <div
            v-else
            class="muContent"
            v-html="eventDesc.setting_json.schedule"
          />
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';
import EventDesc from '@/components/EventDesc.vue';
import EventMenu from '@/components/EventMenu.vue';

export default {
  name: 'EventSchedule',
  components: {
    Breadcrumb,
    EventDesc,
    EventMenu,
  },
  computed: {
    eventDesc: {
      get() {
        return this.$store.state.toGetCurrentEvent.currentEvent;
      },
    },
  },
  mounted() {
    this.$emit('activeIndex', '2');
    this.$emit('pageClass', 'event');
  },
  data() {
    return {
      menuActiveId: '3',
      /*
                muContent: '<p><a href="#"><img class="alignleft" src="http://solopine.com/hemlock/wp-content/uploads/2014/07/flower-300x220.jpg" alt="flower" width="300" height="220"></a>黎明即起，洒扫庭除，要内外整洁，既昏便息，关锁门户，必亲自检点。一粥一饭，当思来处不易；半丝半缕，恒念物力维艰。宜未雨而绸缪，毋临渴而掘井。&nbsp;<a href="#">自奉必须俭约，宴客切勿流连。</a>&nbsp;器具质而洁，瓦缶胜金玉；饮食约而精，园蔬逾珍馐。</p>\n' +
                    '<p>勿营华屋，勿谋良田，三姑六婆，实淫盗之媒；婢美妾娇，非闺房之福。童仆勿用俊美，妻妾切忌艳妆。</p>\n' +
                    '<p>祖宗虽远，祭祀不可不诚；子孙虽愚，经书不可不读。居身务期质朴，教子要有义方。勿贪意外之财，勿饮过量之酒。与肩挑贸易，毋占便宜；见贫苦亲邻，须加温恤。&nbsp;<a href="#">刻薄成家，理无久享；伦常乖舛，立见消亡。</a>&nbsp;</p>\n' +
                    '<p><a href="#"><img class="alignright" src="http://solopine.com/hemlock/wp-content/uploads/2014/07/gal3-300x200.jpg" alt="gal3" width="300" height="200"></a>兄弟叔侄，需分多润寡；长幼内外，宜法肃辞严。听妇言，乖骨肉，岂是丈夫？重资财，薄父母，不成人子。嫁女择佳婿，毋索重聘；娶媳求淑女，勿计厚奁。见富贵而生谄容者，最可耻；遇贫穷而作骄态者，贱莫甚。 居家戒争讼，讼则终凶；处世戒多言，言多必失。勿恃势力而凌逼孤寡，毋贪口腹而恣杀生禽。&nbsp;<a href="#">乖僻自是，悔误必多；颓惰自甘，家道难成。</a>&nbsp;狎昵恶少，久必受其累；屈志老成，急则可相依。</p>\n' +
                    '<p>轻听发言，安知非人之谮诉，当忍耐三思；因事相争，焉知非我之不是，须平心暗想。施惠勿念，受恩莫忘。</p>\n' +
                    '<h1>标题 1</h1>\n' +
                    '<p>凡事当留余地，得意不宜再往。人有喜庆，不可生妒忌心；人有祸患，不可生喜幸心。善欲人见，不是真善；恶恐人知，便是大恶。见色而起淫心，报在妻女；匿怨而用暗箭，祸延子孙。家门和顺，虽饔飧不济，亦有余欢；国课早完，即囊橐无余，自得至乐。</p>\n' +
                    '<hr>\n' +
                    '<h2>标题 2</h2>\n' +
                    '<h3>标题 3</h3>\n' +
                    '<h4>标题 4</h4>\n' +
                    '<h5>标题 5</h5>\n' +
                    '<h6>标题 6</h6>\n' +
                    '<hr>\n' +
                    '<h2>块引用</h2>\n' +
                    '<p>读书志在圣贤，非徒科第；为官心存君国，岂计身家。</p>\n' +
                    '<blockquote><p>守分安命，顺时听天；为人若此，庶乎近焉。</p></blockquote>\n' +
                    '<p>黎明即起，洒扫庭除，要内外整洁，既昏便息，关锁门户，必亲自检点。一粥一饭，当思来处不易；半丝半缕，恒念物力维艰。宜未雨而绸缪，毋临渴而掘井。 自奉必须俭约，宴客切勿流连。器具质而洁，瓦缶胜金玉；饮食约而精，园蔬逾珍馐。</p>\n' +
                    '<p>勿营华屋，勿谋良田，三姑六婆，实淫盗之媒；婢美妾娇，非闺房之福。童仆勿用俊美，妻妾切忌艳妆。祖宗虽远，祭祀不可不诚；子孙虽愚，经书不可不读。居身务期质朴，教子要有义方。勿贪意外之财，勿饮过量之酒。</p>\n' +
                    '<h2>无序列表</h2>\n' +
                    '<p>与肩挑贸易，毋占便宜；见贫苦亲邻，须加温恤。刻薄成家，理无久享；伦常乖舛，立见消亡。兄弟叔侄，需分多润寡；长幼内外，宜法肃辞严。听妇言，乖骨肉，岂是丈夫？重资财，薄父母，不成人子。嫁女择佳婿，毋索重聘；娶媳求淑女，勿计厚奁。见富贵而生谄容者，最可耻；遇贫穷而作骄态者，贱莫甚。居家戒争讼，讼则终凶；处世戒多言，言多必失。</p>\n' +
                    '<ul>\n' +
                    '<li>黎明即起，洒扫庭除，要内外整洁，既昏便息，关锁门户，必亲自检点。</li>\n' +
                    '<li>一粥一饭，当思来处不易；半丝半缕，恒念物力维艰。</li>\n' +
                    '<li>宜未雨而绸缪，毋临渴而掘井。</li>\n' +
                    '<li>自奉必须俭约，宴客切勿流连。</li>\n' +
                    '</ul>\n' +
                    '<h2>清单列表</h2>\n' +
                    '<p>勿恃势力而凌逼孤寡，毋贪口腹而恣杀生禽。乖僻自是，悔误必多；颓惰自甘，家道难成。狎昵恶少，久必受其累；屈志老成，急则可相依。轻听发言，安知非人之谮诉，当忍耐三思；因事相争，焉知非我之不是，须平心暗想。</p>\n' +
                    '<ol>\n' +
                    '<li>器具质而洁，瓦缶胜金玉；饮食约而精，园蔬逾珍馐。</li>\n' +
                    '<li>祖宗虽远，祭祀不可不诚；子孙虽愚，经书不可不读。</li>\n' +
                    '<li>居身务期质朴，教子要有义方。</li>\n' +
                    '<li>勿贪意外之财，勿饮过量之酒。</li>\n' +
                    '<li>与肩挑贸易，毋占便宜；见贫苦亲邻，须加温恤。</li>\n' +
                    '</ol>',

                 */
    };
  },
  watch: {
    '$store.state.toGetCurrentEvent.currentEvent'(v) {
      document.title = '会议日程安排 - ' + v.name;
    },
  },
};
</script>

<style scoped></style>
